import { RESUMEINTELLIGENCE } from "../Action";

const intialState = {
  resumeIntelligenceUpload: {
    data: {},
    file: [],
    status: "",
  },
  resumeIntelligenceSave: {},
};
const ResumeIntelligenceReducer = (state = intialState, action) => {
  switch (action.type) {
    case RESUMEINTELLIGENCE.resumeIntelligenceUpload:
      return {
        ...state,
        resumeIntelligenceUpload: {
          data: action.data.data || {},
          file: action.data.file || [],
          status: action.data.status,
        },
      };
    case RESUMEINTELLIGENCE.resumeIntelligenceSave:
      return { ...state, resumeIntelligenceSave: action.data };
    default:
      return state;
  }
};
export default ResumeIntelligenceReducer;
